export default {
  WHATSAPP_PHONE: '+55 21 97376-4379',
};
